/** `CashCounterApplicationService`'s HTTP surface (Stage 13, Milestone 2 Part 3). */
import { httpClient, unwrap, API_ENDPOINTS } from '@core/api';
import type { ApiSuccessResponse, PaginatedResult } from '@app-types/api.types';
import type { CreateCashCounterRequest, UpdateCashCounterRequest, CashCounterDto } from '@nexao/contracts';

const BASE = API_ENDPOINTS.financial.cashCounters;

export async function listCashCounters(page = 1, limit = 100, branchId?: string): Promise<PaginatedResult<CashCounterDto>> {
  return unwrap(httpClient.get<ApiSuccessResponse<PaginatedResult<CashCounterDto>>>(BASE, { params: { page, limit, branchId } }));
}

export async function createCashCounter(request: CreateCashCounterRequest): Promise<CashCounterDto> {
  return unwrap(httpClient.post<ApiSuccessResponse<CashCounterDto>>(BASE, request));
}

/** PUT, matching the route: every field in the update contract is already optional, so the request IS the patch. */
export async function updateCashCounter(id: string, request: UpdateCashCounterRequest): Promise<CashCounterDto> {
  return unwrap(httpClient.put<ApiSuccessResponse<CashCounterDto>>(`${BASE}/${id}`, request));
}

export async function deactivateCashCounter(id: string): Promise<CashCounterDto> {
  return unwrap(httpClient.post<ApiSuccessResponse<CashCounterDto>>(`${BASE}/${id}/deactivate`, {}));
}

export async function activateCashCounter(id: string): Promise<CashCounterDto> {
  return unwrap(httpClient.post<ApiSuccessResponse<CashCounterDto>>(`${BASE}/${id}/activate`, {}));
}
